import React from 'react';
import { toast } from 'react-toastify';
import { LoruleRequestConfig } from '@galaxy/lorule-react-commons';
import {
    insertContractApproverViewer,
    updateContractApproverViewer,
} from '../../../../api/contractApproversViewersApi';
import { ContractApproverViewerType } from '../../../../api/contractApproversViewersApiTypes';
import { FormType } from '../../../common/types/formTypes';
import { ContractApproversViewersFormType } from './ContractApproversViewersForm';

export const submitContractApproversViewersForm = async (
    config: LoruleRequestConfig,
    formType: FormType,
    values: ContractApproversViewersFormType,
    setResponseError: (errorMessage: string) => void,
    resetForm: () => void,
    setSubmitting: (isSubmitting: boolean) => void,
    toggleModal: () => void,
) => {
    try {
        const newContractApproverViewer: ContractApproverViewerType = {
            id: values.id,
            personId: values.personId,
            approver: values.approver,
            viewer: values.viewer,
            description: values.description,
            startDate: values.startDate ? values.startDate.toString() : '',
            endDate: values.endDate ? values.endDate.toString() : null,
            active: values.active,
            organizationId: values.organizationId,
        };
        if (formType === FormType.CREATE || formType === FormType.CLONE) {
            await insertContractApproverViewer(config, newContractApproverViewer);
            sendToast(
                <>
                    Created Contract Approver/Viewer: <strong>{values.organizationName}</strong>
                </>,
            );
        } else if (formType === FormType.UPDATE) {
            await updateContractApproverViewer(config, newContractApproverViewer);
            sendToast(
                <>
                    Updated Contract Approver/Viewer: <strong>{values.organizationName}</strong>
                </>,
            );
        }
        resetForm();
        toggleModal();

        return true;
    } catch (error) {
        if (error instanceof Error) {
            setResponseError(`${formType.toLowerCase()} failed:  ${error.message}`);
        }
        setSubmitting(false);
        return false;
    }
};

export const sendToast = (content: React.ReactNode) => {
    if (toast) {
        toast.success(content, { hideProgressBar: true });
    }
};
